import React, {CSSProperties} from "react";

export const FormSection: React.FC<{ title?: string, style?: CSSProperties }> = ({title, style, children}) => {
  return <div className={"form-section"} style={style}>
    {title ? <h4 style={{margin: '-.5rem 0 .5rem'}}>{title}</h4> : null}
    {children}
  </div>;
};
